import React from 'react';
import styled, { css } from 'styled-components';

import Scene from '../Scene';
import { crossScreenPaddingBottom, crossScreenPaddingTop, toVw, toVwMobile, toVwTablet } from '../../utils/styles';
import Container from '../../components/Container';
import Indent from '../../components/Indent';
import { FONT_SIZE_MEDIUM_LARGE } from '../../constants';
import history from '../../history';
import mq from '@/utils/media-queries';

const SceneNotFound = styled(Scene)`
  ${crossScreenPaddingTop(265)};
  ${crossScreenPaddingBottom(281)};
`;

const Text = styled.div`
  font-size: ${toVw(FONT_SIZE_MEDIUM_LARGE)};

  ${mq.tablet(css`
    font-size: ${toVwTablet(FONT_SIZE_MEDIUM_LARGE)};
  `)};

  ${mq.mobile(css`
    font-size: ${toVwMobile(64)};
  `)};
`;

class NotFound extends React.Component {
  tickDuration = 1000;
  state = {
    timeoutValue: 10,
  };

  componentDidMount() {
    setTimeout(() => this.startCountdown(), this.tickDuration);
  }

  startCountdown() {
    this.intervalID = setInterval(() => {
      this.setState(state => ({ timeoutValue: state.timeoutValue - 1 }));
    }, this.tickDuration);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.timeoutValue !== prevState.timeoutValue && this.state.timeoutValue === 0) {
      clearInterval(this.intervalID);
      this.redirectToHome();
    }
  }

  redirectToHome() {
    history.push('/');
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <SceneNotFound dark {...this.props}>
        <Container>
          <Indent>
            <Text>
              Ooooh, sh*t. <br />
              Sorry, this page doesn’t exist. <br />
              But, don’t despair, it’s a great chance to see our latest cases. <br />
              Error 404. <br />
              Jump to home <br />
              page in {this.state.timeoutValue}…
            </Text>
          </Indent>
        </Container>
      </SceneNotFound>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/scenes/NotFound/index.js